// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch_switch__AXoXI {
  position: relative;
  display: inline-block;
  width: 40px;
  margin-top: 15px;
  height: 20px;
}

.Switch_switch__AXoXI input {
  opacity: 0;
  width: 0;
  height: 0;
}

.Switch_slider__wnOAX {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--re-from-color);
  transition: 0.4s;
  border-radius: 20px;
}

.Switch_slider__wnOAX::before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .Switch_slider__wnOAX {
  background-color: #4caf50;
}

input:checked + .Switch_slider__wnOAX::before {
  transform: translateX(20px);
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Switch/Switch.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  margin-top: 15px;\n  height: 20px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--re-from-color);\n  transition: 0.4s;\n  border-radius: 20px;\n}\n\n.slider::before {\n  position: absolute;\n  content: '';\n  height: 14px;\n  width: 14px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #4caf50;\n}\n\ninput:checked + .slider::before {\n  transform: translateX(20px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `Switch_switch__AXoXI`,
	"slider": `Switch_slider__wnOAX`
};
export default ___CSS_LOADER_EXPORT___;
